import { render, staticRenderFns } from "./CheckoutSuccess.vue?vue&type=template&id=2c1fd4bc&scoped=true&"
import script from "./CheckoutSuccess.vue?vue&type=script&lang=js&"
export * from "./CheckoutSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fd4bc",
  null
  
)

export default component.exports